__turbopack_context__.v({
  "balanceContainer": "WalletBalanceDisplay-module__Y71vNa__balanceContainer",
  "btcIcon": "WalletBalanceDisplay-module__Y71vNa__btcIcon",
  "btcIconSmall": "WalletBalanceDisplay-module__Y71vNa__btcIconSmall",
  "incomingBalanceContainer": "WalletBalanceDisplay-module__Y71vNa__incomingBalanceContainer",
  "incomingLabel": "WalletBalanceDisplay-module__Y71vNa__incomingLabel",
  "root": "WalletBalanceDisplay-module__Y71vNa__root",
  "skele": "WalletBalanceDisplay-module__Y71vNa__skele",
});
